import { initReactI18next } from 'react-i18next'
import HttpApi from 'i18next-http-backend'
import i18n from 'i18next'
import languageMap from '@amzn/katal-localization/webpack-loader!'
import LanguageDetector from 'i18next-browser-languagedetector'
import { getMetricsPublisherChainAsync } from '@amzn/aapn-front-end-metrics'
import ProductionKeys from 'resources/production.puff.json'

// TODO: incorporate i18next-icu addon if we want to have pluralization / selection support
// Tracking https://issues.amazon.com/issues/KAT-3174 for conversion support for that format
// https://w.amazon.com/bin/view/INTech/Panther/Architecture/PantherFileFormat/JSON/ for panther format examples

if (Object.keys(languageMap).length > 0) {
  i18n.use(HttpApi)
}

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    partialBundledLanguages: true,
    nsSeparator: '-',
    debug: false,
    fallbackLng: ['en-US'],
    load: 'currentOnly',
    backend: {
      loadPath: (localeList: string[]) => {
        return `/partner-network/${languageMap[localeList[0]]}`
      },
    },
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      excludeCacheFor: [], // to allow cimode value to be cached as well - https://github.com/i18next/i18next-browser-languageDetector/blob/9efebe6ca0271c3797bc09b84babf1ba2d9b4dbb/src/index.js#L21
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    saveMissing: true,
    // This handler will only execute as a last resort when no fallback was found
    missingKeyHandler: (_fallbackLng, ns, key, fallbackValue) => {
      // Sometimes the key is null or empty and when that happens the metrics aren't very useful.
      if (!!key) {
        // Implies the key is valid, but something went wrong with this client's ability to get the translated value
        // Purely tracking and to cut down on un-actionable ticketing
        if (key in ProductionKeys.resources) {
          return getMetricsPublisherChainAsync('i18n').then((p) =>
            p
              .publishCounter(`missingValidKey.${localStorage.i18nextLng}.${key}`, 1)
              .publishCounter(`missingValidKey`, 1)
              .publishString('key', key)
              .publishString('locale', localStorage.i18nextLng)
              .publishString('userAgent', window?.navigator?.userAgent),
          )
        }
        // Implies the key is likely invalid or we made a code error in retrieving the key
        // Triggers: https://carnaval.amazon.com/viewObject.do?name=AAPNStageDiveStaticWebsite.missingKey&type=monitor
        return getMetricsPublisherChainAsync('i18n').then((p) =>
          p
            .publishCounter(`missingKey.${localStorage.i18nextLng}.${key}`, 1)
            .publishCounter(`missingKey`, 1)
            .publishString('key', key)
            .publishString('locale', localStorage.i18nextLng)
            .publishString('userAgent', window?.navigator?.userAgent),
        )
      }
    },
  })

export default i18n
